import React from "react";
import PropTypes from "prop-types";
import { Toast } from "@ebscois/react-component-library";
import { clearNotification } from "../../store/actions";
import { useDispatch } from "../../store";

const Notification = ({ notification }) => {
  if (notification?.isOpen && notification?.type === "error") {
    window?.DD_RUM?.addError(
      new Error(
        `Platform content MFE error with message: ${notification?.message}`
      ),
      {
        scope: "platform-content",
        team: "cd.mergeconflict",
      }
    );
  }
  const { type, message, isOpen = false } = notification || {};
  const dispatch = useDispatch();
  const handleClose = () => {
    clearNotification({ dispatch });
  };
  return (
    <div onClick={handleClose} data-testid={"notification-toast-wrapper"}>
      <Toast
        isOpen={isOpen}
        onClose={handleClose}
        type={type}
        children={message}
        data-testid={"notification-toast"}
      />
    </div>
  );
};

Notification.defaultProps = {
  notification: { isOpen: false },
};

Notification.propTypes = {
  notification: PropTypes.shape({
    type: PropTypes.oneOf(["success", "warning", "error", "info"]),
    message: PropTypes.string,
    isOpen: PropTypes.bool,
  }).isRequired,
};

Notification.componentName = "Notification";

export default Notification;
